// extracted by mini-css-extract-plugin
export default {"container":"M82KG3","mobile":"L7PIOW"};